import React, { createContext, useContext } from "react"
import { useCart } from "../hooks/useCart"

const CartContext = createContext<any>(null)

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const cart = useCart()
    return <CartContext.Provider value={cart}>{children}</CartContext.Provider>
}

export const useCartContext = () => useContext(CartContext)